import React from 'react';
import { NavLink, withRouter } from 'react-router-dom';
import { translate, Trans } from 'react-i18next'

import styles from './mainnavigation.scss'

const MainNavigation = ({ t, match, location, children }) => {

  return (
    <div className="main-navigation">
      <ul className="main-navigation-list">
        <li className="main-navigation-item">
          <NavLink className="main-navigation-link" to={{
            pathname: `/organisations/${match.params.organisationId}/profiles`,
            search: location.search
          }}>
            {t('MAP')}
          </NavLink>
        </li>
        {/*<li className="main-navigation-item">
          <NavLink className="main-navigation-link" to={{
            pathname: `/organisations/${match.params.organisationId}/events`,
            search: location.search
          }}>
            {t('CALENDAR')}
          </NavLink>
        </li>*/}
        <li className="main-navigation-item">
          <NavLink className="main-navigation-link" to={{
            pathname: `/organisations/${match.params.organisationId}/visual`,
            search: location.search
          }}>
            {t('VISUAL')}
          </NavLink>
        </li>
      </ul>
      {children}
    </div>
  )
}
export default translate('nav')(withRouter(MainNavigation))



// WEBPACK FOOTER //
// ./src/components/layout/MainNavigation.js